import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ConfiguratorDatastoreService, UserDTO} from '@tj/tj-dmp-lib-api';
import {SelectItem} from 'primeng/api';
import {AccountService} from '../../auth/account.service';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'dmp-select-datastore',
    templateUrl: './select-datastore.component.html',
    styleUrls: ['./select-datastore.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: SelectDatastoreComponent
        }
    ],
    standalone: false
})
export class SelectDatastoreComponent implements OnInit, OnChanges, ControlValueAccessor {

    constructor(
        protected datastoreResourceService: ConfiguratorDatastoreService,
        protected accountService: AccountService,
        private cref: ChangeDetectorRef
    ) {
    }

    datastore: any; // SelectItem;
    datastores: any[]; // SelectItem[];
    datastoresCache: any[]; // SelectItem[];

    @Input() inputId = '';
    @Input() fluid = false;
    @Input() value: string;
    @Output() change = new EventEmitter<SelectItem>();
    @Input() disabled = false;
    @Input() cache = true;
    @Input() emptyFirstElement = false;
    @Input() emptyFirstElementLabel = '';
    touched = false;
    user: UserDTO;

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange = (value) => {
        this.updateValue();
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onTouched = () => {
    }


    writeValue(codePartner: any): void {
        this.value = codePartner;
        this.updateValue();
    }

    registerOnChange(onChange: any) {
        this.onChange = onChange;
    }

    registerOnTouched(onTouched: any) {
        this.onTouched = onTouched;
    }
    setDisabledState(disabled: boolean) {
        this.disabled = disabled;
    }
    markAsTouched() {
        if (!this.touched) {
            this.onTouched();
            this.touched = true;
        }
    }

    ngOnInit() {
        this.datastoreResourceService.getAllDatastoresUsingGET().subscribe(res => {
            this.datastoresCache = [];
            if (this.emptyFirstElement) {
                this.datastoresCache.push({
                    label: this.emptyFirstElementLabel,
                    value: null,
                    partners: []
                });
            }
            res.forEach(itemDatastore => {
                this.datastoresCache.push({
                    id: itemDatastore.id,
                    label: itemDatastore.name,
                    value: itemDatastore.code,
                    partners: itemDatastore.partners
                });
            });
            //
            this.updateList();
        });

        this.accountService.getAuthenticationState().subscribe((user: UserDTO) => {
            this.user = user;
            this.updateList();
        });
    }

    private updateList() {
        if (this.datastoresCache && this.user) {

            this.datastores = JSON.parse(JSON.stringify(this.datastoresCache));
            /*.filter(d => {
                return this.user.hasTenant(d.value);
            });*/
        }
        this.updateValue();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.value) {
            this.updateValue();
        }
    }

    private updateValue() {
        if (this.datastores == null) {
            return;
        }
        if (this.value) {
            this.datastore = this.datastores.find(d => d.value === this.value);
            return;
        } else if (this.emptyFirstElement || this.datastore == null) {
            this.datastore = this.datastores[0];
            this.datastoreChange();
        }
        // this.cref.detectChanges();
    }

    datastoreChange() {
        if (this.datastore != null && !this.disabled) {
            this.onChange((this.datastore as SelectItem).value);
            this.markAsTouched();
            this.change.emit(this.datastore);
        }
    }

}
